<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">T<span class="smallcaps">HE </span>F<span class="smallcaps">IRST </span>S<span class="smallcaps">TORY</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// trust_00002.vue?14ca9342